/** Vacation Tracker knowledge-base article URLs referenced from the app UI (empty-state links,
 * inline help). Add new entries here so callsites stay tidy and a URL change updates every
 * consumer. */

export const KB_URLS = {
  labelsHowTo: 'https://vacationtracker.io/knowledge-base/how-can-i-categorize-users-adding-labels/',
} as const
